import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-delete-qris-modal',
  templateUrl: './delete-qris-modal.component.html',
  styleUrl: './delete-qris-modal.component.scss'
})
export class DeleteQrisModalComponent {
  @Input() isVisible: boolean = false;
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  handleCancel() {
    this.cancel.emit();
  }

  handleConfirm() {
    this.confirm.emit();
  }
}
